import Vue from 'vue'
//import VueRouter, { RouteConfig } from 'vue-router'
import VueRouter from 'vue-router'

import ChangeLogList from '@/components/app/ChangeLogList.vue';
import UserDashboard from '@/components/dashboards/UserDashboard.vue'
import UrgentReminderList from '@/components/dashboards/UrgentReminderList.vue'
import ReminderEdit from '@/components/dashboards/ReminderEdit.vue'
import DiamondList from '@/components/diamonds/DiamondList.vue'

import AssociateCommission from '@/components/associates/AssociateCommission.vue'
import Associates from '@/components/associates/Associates.vue'
import AssociateDetail from '@/components/associates/AssociateDetail.vue'
import AssociatePersonalEnrollments from '@/components/associates/AssociatePersonalEnrollments.vue'
import NoteAdd from '@/components/associates/NoteAdd.vue'
import NoteList from '@/components/associates/NoteList.vue'
import NoteEdit from '@/components/associates/NoteEdit.vue'
import ReminderAdd from '@/components/associates/ReminderAdd.vue'
import AssociateRankHistory from '@/components/associates/AssociateRankHistory.vue'

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/about',
      component: ChangeLogList,
    },
    {
      path: '/userDashboard',
      name: 'user-dashboard',
      component: UserDashboard,
      children: [
        {
          path: 'urgentReminderList',
          name: 'urgent-reminder-list',
          component: UrgentReminderList,
          children: [{
            path: `:id/reminderEdit`,
            name: 'reminder-popup-edit',
            component: ReminderEdit
          }],
        },
        {
          path: ':id/reminderEdit',
          name: 'reminder-edit',
          component: ReminderEdit,
        },
      ],
    },
    {
      path: '/DSPlus/:id',
      name: 'DSPlus',
      component: AssociateCommission,
    },
    {
      path: '/associates',
      name: 'associates',
      component: Associates,
      children: [
        {
          path: ':id/detail',
          name: 'detail',
          component: AssociateDetail,
          children: [
            {
              path: 'associatePersonalEnrollments',
              name: 'enrollments',
              component: AssociatePersonalEnrollments,
            },
            {
              path: 'noteAdd',
              name: 'note-add',
              component: NoteAdd,
            },
            {
              path: 'notesList',
              name: 'note-list',
              component: NoteList,
              children: [{
                path: ':noteId/noteEdit',
                name: 'note-edit',
                component: NoteEdit
              }],
            },
            {
              path: 'reminderAdd',
              name: 'reminder-add',
              component: ReminderAdd,
            },
            {
              path: 'rankHistory',
              name: 'rank-history',
              component: AssociateRankHistory,
            },
          ],
        }
      ],
    },
    {
      path: '/diamondList',
      name: 'diamondList',
      component: DiamondList,
    },

  ],
});

